import Navigator from "./navigator";

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          get navigator() {
            return Navigator;
          },
        };
      },
    });
  },
};
